import { Load, otaLoadSchema } from "@fatbees/schemas";

export async function putLoad(load: Load): Promise<void> {
  const response = await fetch(`/api/loads/${encodeURIComponent(load.id)}`, {
    method: "PUT",
    body: JSON.stringify({
      name: load.name,
      retiredAt: load.retiredAt,
      isScout: load.isScout,
    }),
    headers: { "content-type": "application/json" },
    credentials: "same-origin",
  });
  if (!response.ok) {
    throw new Error(response.statusText);
  }
  otaLoadSchema.parse(await response.json());
}

export async function deleteLoad(load: Load): Promise<void> {
  const response = await fetch(`/api/loads/${encodeURIComponent(load.id)}`, {
    method: "DELETE",
    credentials: "same-origin",
  });
  if (!response.ok) {
    throw new Error(response.statusText);
  }
}
